import { config } from '@js/index';

const SCREEN_W = 1280;
const SCREEN_H = 720;

export default class LV2EndScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LV2EndScene' });
  }

  preload() {
    this.load.image('lv2EndOverlay', 'assets/EndScreenAssets/end screen.png');
    this.load.image('lv2YouWon', 'assets/EndScreenAssets/You Won.png');
    this.load.image('lv2NextBtn', 'assets/EndScreenAssets/Button CTA.png');
    this.load.image('lv2NextHover', 'assets/EndScreenAssets/next hover.png');
    this.load.image('lv2OkayBtn', 'assets/EndScreenAssets/okaybutton.png');
    this.load.image('lv2OkayHover', 'assets/EndScreenAssets/okayHover.png');
    this.load.image('lv2OkayDisabled', 'assets/EndScreenAssets/okayDisabled.png');
    this.load.image('lv2RewardEarned', 'assets/EndScreenAssets/Rewards earned!.png');
    this.load.image('lv2RewardName', 'assets/EndScreenAssets/shakeJar-name.png');
    this.load.image('lv2RewardJar', 'assets/EndScreenAssets/shakeJar.png');

    this.load.multiatlas(
      'lv2EndSpotlight',
      'assets/EndScreenAssets/spotlight/spotlightAnimNew.json',
      'assets/EndScreenAssets/spotlight',
    );
    this.load.multiatlas(
      'lv2EndConfetti',
      'assets/EndScreenAssets/confetti/confettiAnimNew.json',
      'assets/EndScreenAssets/confetti',
    );
  }

  create() {
    this.cameras.main.fadeIn(800, 255, 255, 255);

    this.fadeOutAudio(config.audio?.BirdsWingBG);
    this.fadeOutAudio(config.audio?.mainBG);

    if (config.audio?.LogoReveal && !config.audio.LogoReveal.isPlaying) {
      config.audio.LogoReveal.play();
    }

    this.endOverlay = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'lv2EndOverlay');

    this.spotlight = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'lv2EndSpotlight');
    this.anims.create({
      key: 'lv2EndSpotlightOpen',
      frames: this.anims.generateFrameNames('lv2EndSpotlight', {
        start: 0,
        end: 188,
        zeroPad: 0,
        prefix: 'spotlight0',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.endConfetti = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'lv2EndConfetti');
    this.anims.create({
      key: 'lv2EndConfettiAnim',
      frames: this.anims.generateFrameNames('lv2EndConfetti', {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.time.delayedCall(2000, () => {
      this.spotlight.play('lv2EndSpotlightOpen');
    });

    this.youWon = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'lv2YouWon').setAlpha(0);
    this.tweens.add({
      targets: this.youWon,
      ease: 'Expo.easeInOut',
      duration: 1000,
      delay: 300,
      alpha: 1,
    });
    this.tweens.add({
      targets: this.youWon,
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      y: SCREEN_H / 2 - 50,
    });

    this.endConfetti.play('lv2EndConfettiAnim');

    this.nextButton = this.add
      .sprite(SCREEN_W / 2, 740, 'lv2NextBtn')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.tweens.add({
      targets: this.nextButton,
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      alpha: 1,
      y: 650,
    });

    this.reward = this.add
      .image(SCREEN_W / 2, SCREEN_H / 2, 'lv2RewardJar')
      .setScale(0)
      .setVisible(false);

    this.okButton = this.add
      .sprite(SCREEN_W / 2, 740, 'lv2OkayBtn')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.nextButton.on('pointerover', () => this.nextButton.setTexture('lv2NextHover'));
    this.nextButton.on('pointerout', () => this.nextButton.setTexture('lv2NextBtn'));

    this.nextButton.on('pointerup', () => {
      this.tweens.add({
        targets: [this.youWon, this.nextButton],
        alpha: 0,
        duration: 300,
      });

      this.time.delayedCall(1000, () => {
        this.reward.setVisible(true);
        this.tweens.add({
          targets: this.reward,
          ease: 'Back.easeOut',
          duration: 700,
          scale: 1.5,
          onComplete: () => {
            this.tweens.add({
              targets: this.reward,
              ease: 'Sine.easeInOut',
              duration: 1400,
              yoyo: true,
              repeat: -1,
              y: SCREEN_H / 2 - 15,
            });
          },
        });
        this.add.sprite(581, 126, 'lv2RewardEarned').setOrigin(0);
        this.add.sprite(578, 580, 'lv2RewardName').setOrigin(0);

        this.tweens.add({
          targets: this.okButton,
          ease: 'Linear',
          duration: 300,
          delay: 3000,
          alpha: 1,
          y: 650,
        });
      });
    });

    this.okButton.on('pointerover', () => this.okButton.setTexture('lv2OkayHover'));
    this.okButton.on('pointerout', () => this.okButton.setTexture('lv2OkayBtn'));
    this.okButton.on('pointerup', () => {
      this.okButton.setTexture('lv2OkayDisabled');
      this.okButton.removeInteractive();
    });
  }

  fadeOutAudio(sound) {
    if (!sound) return;
    this.tweens.add({
      targets: sound,
      volume: 0,
      duration: 1000,
      onComplete: () => {
        if (sound && typeof sound.stop === 'function') sound.stop();
      },
    });
  }

  update() {}
}
